// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2m3-n","search":"Settings_search__3Sohr","filter":"Settings_filter__3N29e"};